module.exports = __webpack_public_path__ + "img/ico_order_pickup.632763e.png";